import React, {useCallback} from 'react';

import {RunColorOptions, SemanticLegendSettings} from '../types';
import {SemanticLegendBuckets} from './SemanticLegendBuckets';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from './SemanticLegendDefaults';
import {SemanticLegendExcludedRunColor} from './SemanticLegendExcludedRunColor';
import {SemanticLegendMetric} from './SemanticLegendMetric';
import {SemanticLegendNumBuckets} from './SemanticLegendNumBuckets';
import {SemanticLegendRunColorOptions} from './SemanticLegendRunColorOptions';
import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsContextProvider';
import {SemanticLegendYValue} from './SemanticLegendYValue';

export const SemanticLegendColorTab = () => {
  const {
    semanticLegendSettings,
    semanticLegendRunColorOptions,
    isMetricBasedColors,
    updateSemanticLegendRunColorOptions,
    updateSemanticLegendSettingsOptimistically,
  } = useSemanticLegendSettingsContext();

  const {hasActiveGrouping} = useSemanticLegendSettingsContext();
  const showMetricBasedColors = !hasActiveGrouping && isMetricBasedColors;

  const updateSetting = useCallback(
    (value: Partial<SemanticLegendSettings>) => {
      updateSemanticLegendSettingsOptimistically?.({
        ...semanticLegendSettings,
        ...value,
      });
    },
    [semanticLegendSettings, updateSemanticLegendSettingsOptimistically]
  );
  return (
    <div
      data-test="workspace-semantic-legend-color-settings"
      className={'flex h-full w-full flex-col gap-20 py-16'}>
      <SemanticLegendRunColorOptions
        hasActiveGrouping={hasActiveGrouping}
        runColorOptions={
          semanticLegendRunColorOptions ?? RunColorOptions.OriginalProjectColors
        }
        onRunColorOptionsChange={value => {
          updateSemanticLegendRunColorOptions?.(value);
        }}
      />
      {showMetricBasedColors && (
        <SemanticLegendMetric
          metric={semanticLegendSettings?.metric ?? ''}
          updateSetting={updateSetting}
        />
      )}
      {showMetricBasedColors &&
        semanticLegendSettings?.metric &&
        semanticLegendSettings?.metric !==
          DEFAULT_SEMANTIC_LEGEND_SETTINGS.metric && (
          <div className={'flex h-full w-full flex-col'}>
            <SemanticLegendYValue
              yValue={
                semanticLegendSettings?.yAxisValue ??
                DEFAULT_SEMANTIC_LEGEND_SETTINGS.yAxisValue
              }
              updateSetting={updateSetting}
            />
            <SemanticLegendNumBuckets
              numberOfBuckets={semanticLegendSettings?.numberOfBuckets ?? 0}
              updateSetting={updateSetting}
            />
            <SemanticLegendBuckets
              bucketCustomizations={
                semanticLegendSettings?.bucketCustomizations ?? {}
              }
              buckets={semanticLegendSettings?.buckets ?? []}
              updateSetting={updateSetting}
            />
            <SemanticLegendExcludedRunColor
              excludedRunColor={semanticLegendSettings?.excludedRunColor ?? ''}
              updateSetting={updateSetting}
            />
          </div>
        )}
    </div>
  );
};
